module.exports = __webpack_public_path__ + "img/111.d47af341.png";